export const AppSettings = Object.freeze({
    "SERVER_URL": 'https://mobile-api.atarix.co.il/activtecAppApi/api/',
    "APP_VERSION": 'https://mobile-api.atarix.co.il/activtecAppApi/app_version.php',
    "ROO_API": 'https://admin.roo.org.il/api/',
    "SECURITY_KEY": '',
    "FACEBOOKID": '',
    "TOAST": {
        "duration": 3000,
        "position": "buttom"
    },
});


// WEBPACK FOOTER //
// ./src/services/app-settings.ts